/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Silent PWA updates work via the SW caching strategy (see vue.config.js):
// index.html is never cached, so every navigation fetches fresh HTML that
// references the currently-live chunk filenames. There is no stale-chunk
// race, no popup, no reload dance — the new version is simply there the
// next time the user opens or reloads the app.

if (process.env.VUE_APP_NODE_ENV === 'development' ||
    process.env.VUE_APP_NODE_ENV === 'aws-development' ||
    process.env.VUE_APP_NODE_ENV === 'aws-production') {
  console.log('Register service worker for baseURL:  ' + process.env.BASE_URL)
  register(`${process.env.BASE_URL}service-worker.js`, {
    registrationOptions: {
      scope: process.env.BASE_URL,
    },
    ready() {
      console.log('App is being served from cache by a service worker.');
    },
    registered() {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updated() {
      console.log('New content is available.');
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    }
  });
}
